import React from 'react'
import { Box, Typography } from '@mui/material'

import { Button } from '../../../../interaxDesignSystemComponents'
import { INTERAX_COLORS } from '../../../../constants/colors'

interface InviteUsersConfirmPanelProps {
  heading: string
  body: string
  helper: string
  confirmLabel: string
  cancelLabel: string
  loadingLabel: string
  isLoading: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const InviteUsersConfirmPanel: React.FC<InviteUsersConfirmPanelProps> = ({
  heading,
  body,
  helper,
  confirmLabel,
  cancelLabel,
  loadingLabel,
  isLoading,
  onConfirm,
  onCancel
}) => {
  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '16px', minHeight: 0 }}>
      <Box
        sx={{
          flex: 1,
          padding: '20px',
          borderRadius: '16px',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          border: `1px solid ${INTERAX_COLORS.sun}`,
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}
      >
        <Typography sx={{ color: INTERAX_COLORS.white, fontWeight: 600, fontSize: '20px' }}>{heading}</Typography>
        <Typography sx={{ color: INTERAX_COLORS.thunderGrey, fontSize: '15px' }}>{body}</Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: '12px',
          width: '100%',
          flexWrap: 'nowrap'
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading} fullWidth>
            {isLoading ? loadingLabel : confirmLabel}
          </Button>
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Button variant="secondary" onClick={onCancel} disabled={isLoading} fullWidth>
            {cancelLabel}
          </Button>
        </Box>
      </Box>
      <Typography sx={{ color: INTERAX_COLORS.thunderGrey, fontSize: '13px', textAlign: 'center' }}>
        {helper}
      </Typography>
    </Box>
  )
}
